import { DEV } from "solid-js"
import Unexpected from "../../../Exception/Unexpected.class"
import type { NeighborWeights } from "./NeighborWeights.type"

/**
 * Elevations for the 8 neighbours in the same order as eightDirections.
 * `base` is the elevation of the centre tile.
 */
export type NeighborElevations = {
  base: number
  avgs: number[]  // length === 8
}

/**
 * Weighted interpolation of elevation at an arbitrary point inside a tile.
 *
 * @param weights   WeightsV2 from calculateNeighborWeights
 * @param elev      ElevationsV2 for base + 8 neighbours
 * @returns         The interpolated elevation
 */
export default function calculateNodeVertexElevation(
  weights: NeighborWeights,
  elev: NeighborElevations,
): number {

  const { base: wBase, list: wList, total } = weights
  const { base: eBase, avgs: eList } = elev

  if (DEV) {
    if (wList.length !== 8) {
      throw new Unexpected('wList.length !== 8')
    }
    if (eList.length !== 8) {
      throw new Unexpected('eList.length !== 8')
    }
  }

  let sum = wBase * eBase
  // let total2 = wBase
  for (let i = 0; i < 8; i++) {
    sum += wList[i] * eList[i]
    // total2 += wList[i]
  }

  // if (total !== total2) {
  //   console.log('total', total, 'total2', total2)
  //   throw new Unexpected('total !== total2')
  // }

  // if (total !== 1) {
  //   console.log('sum', sum, 'total', total)
  // }

  // If total is zero (shouldn’t happen), fall back to base elevation
  return (total > 0 ? sum / total : eBase) / 2
}
